import m from "../../geodata/es2015/maltaHigh";
window.am4geodata_maltaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/maltaHigh.js
// module id = null
// module chunks = 